import request from '../utils/request';
//支付宝支付
export function payEnd(data) {
  return request({
    url: 'order/webPayEnd.do',
    method: 'post',
    data,
  })
}

//支付宝对账
export function toTradeQueryZFB(data) {
  return request({
    url: 'order/toTradeQueryZFB.do',
    method: 'post',
    data,
  })
}

//获取订单信息
export function toPayOrder(data) {
  return request({
    url: 'order/toOrderCancelTime.do',
    method: 'post',
    data,
  })
}

//支付成功
export function toPaySuccess(data) {
  return request({
    url: 'order/toPaySuccess.do',
    method: 'post',
    data,
  })
}

//
export function getOrderPayInfo(data) {
  return request({
    url: 'order/getOrderPayInfo.do',
    method: 'post',
    data,
  })
}

//vx对账
export function toTradeQueryWX(data) {
  return request({
    url: 'order/toTradeQueryWX.do',
    method: 'post',
    data,
  })
}

//申请表截图
export function healthScreenshot(data) {
  return request({
    url: 'order/healthScreenshot.html',
    method: 'post',
    data,
  })
}
//承诺书截图
export function healthCertificate(data) {
  return request({
    url: 'userData/healthCertificate.html',
    method: 'post',
    data,
  })
}
//学籍卡截图
export function studentCard(data) {
  return request({
    url: 'order/studentCard.html',
    method: 'post',
    data,
  })
}

//学习卡支付
export function toUseCardPay(data) {
  return request({
    url: 'order/toUseCardPay.do',
    method: 'post',
    data,
  })
}